import React from 'react';

import axios from 'axios';
import Qs from 'qs'
import { toast } from 'react-toastify';
import Swal from 'sweetalert2'
import { clearSession } from '../../session';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



export const getSingleFilePath = (code_files, target_id, root_id) => {
    let file=getSingleFile(code_files, target_id);
    let path="";
    while(file!==null&&file.id!==root_id)
    {
        if(path==="")
        {
            path=file.name;
        }
        else
        {
            path=file.name+"/"+path;
        }
        file=getSingleFile(code_files, file.parentid);
    }
    return path;
}

export const sortFiles = (code_files) => {
    code_files.sort((a, b) => ((a.type + a.name) > (b.type + b.name)) ? 1 : -1);
    for (let i = 0; i < code_files.length; i++) {
        if (code_files[i].files && code_files[i].files.length > 0) {
            sortFiles(code_files[i].files);
        }
    }
}


export const addSingleFile = (code_files, new_code_file) => {
    for (let i = 0; i < code_files.length; i++) {
        if (code_files[i].id === new_code_file.parentid) {
            new_code_file.level = code_files[i].level + 1;
            new_code_file.isShare = code_files[i].isShare;
            new_code_file.role=code_files[i].role;
            code_files[i].files.push(new_code_file);
            break;
        }
        else if (code_files[i].files && code_files[i].files.length > 0) {
            addSingleFile(code_files[i].files, new_code_file);
        }
    }
}

export const getSingleFile = (code_files, code_file_id) => {
    for (let i = 0; i < code_files.length; i++) {
        if (code_files[i].id === code_file_id) {
            return code_files[i];
        }
        else if (code_files[i].files && code_files[i].files.length > 0) {
            let temp = getSingleFile(code_files[i].files, code_file_id);
            if (temp !== null) {
                return temp;
            }
        }
    }
    return null;
}


export const clearSingleCodeFile = (code_files, code_file_id) => {
    for (let i = 0; i < code_files.length; i++) {
        if (code_files[i].path === code_file_id) {
            code_files[i].files = [];
            return 1;
        }
        else if (code_files[i].files && code_files[i].files.length > 0) {
            let temp = clearSingleCodeFile(code_files[i].files, code_file_id);
            if (temp === 1) {
                return temp;
            }
        }
    }
    return 0;
}

export const deleteSingleFile = (code_files, code_file_id) => {
    for (let i = 0; i < code_files.length; i++) {
        if (code_files[i].id === code_file_id) {
            code_files.splice(i, 1);
            return 1;
        }
        else if (code_files[i].files && code_files[i].files.length > 0) {
            let temp = deleteSingleFile(code_files[i].files, code_file_id);
            if (temp === 1) {
                return temp;
            }
        }
    }
    return 0;
}

export const handleCloseUploadingModal = () => {
    let div = document.getElementById("uos_upload_file_progress_div");
    let files = div.querySelectorAll(".file_upload_status");
    if (files.length === undefined || files === null || files.length === 0) {
        div.style.display = "none";
    }
    else {
        let hasFile = false;
        for (let i = 0; i < files.length; i++) {
            let status = parseInt(files[i].getAttribute("status"));
            if (status === 0) {
                hasFile = true;
                break;
            }
        }
        if (hasFile) {
            Swal.fire('Operation Error', "You have files uploading now, please cancel first!", 'error');
            return;
        }
        else {
            let instances = div.querySelectorAll(".file_upload_instance");
            for (let i = 0; i < instances.length; i++) {
                instances[i].remove();
            }
            div.style.display = "none";

        }
    }
}

export const getFileUploadUI = () => {
    return <div className="p-2 rounded" style={{ position: "fixed", border: "1px gray solid", bottom: "50px", right: "20px", display: "none", zIndex: 10000, minWidth: "250px", minHeight: "20px", background: "lightgray" }} id="uos_upload_file_progress_div" >
        <div className="justify-content-between align-items-center d-flex mb-3">
            <span>Files Uploading</span>
            <FontAwesomeIcon onClick={() => handleCloseUploadingModal()} icon={['fas', 'times-circle']} className="font-size-lg cursor_pointer ml-3" />
        </div>
    </div>;
}

export const getFileIcon=(name)=> {
    if(name===null)
    {
        return <FontAwesomeIcon icon={['fas', 'file-alt']} style={{ fontSize: "40px" }} />;
    }
    let file_name = (name.split(".").pop()).toLowerCase();
    if (file_name === "pdf") {
        return <FontAwesomeIcon icon={['fas', 'file-pdf']} style={{ fontSize: "40px" }}/>;
    }
    else if (file_name === "doc" || file_name === "docx") {
        return <FontAwesomeIcon icon={['fas', 'file-word']} style={{ fontSize: "40px" }} />;
    }
    else if (file_name === "csv" || file_name === "csvx") {
        return <FontAwesomeIcon icon={['fas', 'file-csv']} style={{ fontSize: "40px" }}/>;
    }
    else if (file_name === "ppt" || file_name === "pptx") {
        return <FontAwesomeIcon icon={['fas', 'file-powerpoint']} style={{ fontSize: "40px" }} />;
    }
    else if (file_name === "xls" || file_name === "xlsx") {
        return <FontAwesomeIcon icon={['fas', 'file-excel']} style={{ fontSize: "40px" }} />;
    }
    else if (file_name === "png" || file_name === "jpeg" || file_name === "gif" || file_name === "jpg") {
        return <FontAwesomeIcon icon={['fas', 'file-image']} style={{ fontSize: "40px" }} />;
    }
    else if (file_name === "zip" || file_name === "rar" || file_name === "war") {
        return <FontAwesomeIcon icon={['fas', 'file-archive']} style={{ fontSize: "40px" }} />;
    }
    else if (file_name === "py" || file_name === ".java" || file_name === "js"||file_name==="cc"||file_name==="cpp") {
        return <FontAwesomeIcon icon={['fas', 'file-code']} style={{ fontSize: "40px" }} />;
    }
    else if (file_name === "mp4") {
        return <FontAwesomeIcon icon={['fas', 'play-circle']} style={{ fontSize: "40px" }} />;
    }
    else {
        return <FontAwesomeIcon icon={['fas', 'file-alt']} style={{ fontSize: "40px" }} />;
    }
}

export const handFileActions = (action_name, callback, v1, v2, v3, v4, v5, v6, v7, v8) => {
    if (action_name === "upload_files") {
        let fileInput = v2;
        let parentid = v1;
        if (fileInput.files === null || fileInput.files.length === 0) {
            Swal.fire('Invalid Operation', 'You must at least select 1 file', 'error');
            fileInput.value = "";
            return;
        }
        let names = "";
        for (let i = 0; i < fileInput.files.length; i++) {
            let fsize = fileInput.files[i].size;
            let fileName = fileInput.files[i].name;
            names = names + fileName + "<br/>";
            fsize = Math.round((fsize / 1024));
        }

        let formData = new FormData();

        // for (let i = 0; i < fileInput.files.length; i++) {
        //     let fsize = fileInput.files[i].size;
        //     fsize = Math.round((fsize / 1024));
        // }
        let ajaxRequest = axios.CancelToken.source();

        let session = window.localStorage;
        for (var i = 0; i < fileInput.files.length; i++) {
            formData.append('file_datas', fileInput.files[i]);
        }
        formData.append('token', session.ch_token);
        formData.append('parentid', parentid);
        let upload_url=session.ch_action_url + "/action/add_new_project_file";

        let upload_status_parent = document.getElementById("uos_upload_file_progress_div");
        upload_status_parent.style.display = "block";

        let single_progress = document.createElement("div");
        let single_file_attr = document.createAttribute("class");
        single_file_attr.value = "file_upload_instance";
        single_progress.setAttributeNode(single_file_attr);

        let file_name_span_node = document.createElement("span");
        let span_file_attr = document.createAttribute("class");
        span_file_attr.value = "mb-2";
        file_name_span_node.setAttributeNode(span_file_attr);
        file_name_span_node.innerHTML = names;
        //file_name_span_node.appendChild(document.createTextNode(names));
        single_progress.appendChild(file_name_span_node);

        let progress_bar_div = document.createElement("div");
        let classAttr = document.createAttribute("class");
        classAttr.value = "progress-bar bg-success";
        progress_bar_div.setAttributeNode(classAttr);

        let valuenow = document.createAttribute("aria-valuenow");
        valuenow.value = "0";
        progress_bar_div.setAttributeNode(valuenow);


        let valuemin = document.createAttribute("aria-valuemin");
        valuemin.value = "0";
        progress_bar_div.setAttributeNode(valuemin);


        let valuemax = document.createAttribute("aria-valuemax");
        valuemax.value = "100";
        progress_bar_div.setAttributeNode(valuemax);

        let style_1 = document.createAttribute("style");
        style_1.value = "width:0%";
        progress_bar_div.setAttributeNode(style_1);

        progress_bar_div.appendChild(document.createTextNode("0%"));
        //progress_bar_div.innerHTML="0%";

        let progress_div = document.createElement("div");
        let progress_classAttr = document.createAttribute("class");
        progress_classAttr.value = "progress";
        progress_div.setAttributeNode(progress_classAttr);

        var style_0 = document.createAttribute("style");
        style_0.value = "width:200px";
        progress_div.setAttributeNode(style_0);


        progress_div.appendChild(progress_bar_div);

        let progress_all_div = document.createElement("div");
        let classAttr0 = document.createAttribute("class");
        classAttr0.value = "d-flex";
        progress_all_div.setAttributeNode(classAttr0);
        progress_all_div.appendChild(progress_div);

        let file_name_span_node_close = document.createElement("span");

        var f_classAttr = document.createAttribute("class");
        f_classAttr.value = "file_upload_status";
        file_name_span_node_close.setAttributeNode(f_classAttr);

        var style_2 = document.createAttribute("style");
        style_2.value = "display:block";
        file_name_span_node_close.setAttributeNode(style_2);

        var status_a = document.createAttribute("status");
        status_a.value = "0";
        file_name_span_node_close.setAttributeNode(status_a);
        file_name_span_node_close.innerHTML = '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times-circle" class="svg-inline--fa fa-times-circle fa-w-16 cursor_pointer ml-2" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="position: relative;top:-3px;"><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"></path></svg>';
        file_name_span_node_close.addEventListener('click', () => {
            let status = parseInt(file_name_span_node_close.getAttribute("status"));
            if (status === 1) {
                single_progress.remove();
                handleCloseUploadingModal();
            }
            else {
                ajaxRequest.cancel();
                formData.delete('file_datas');
                single_progress.remove();
                handleCloseUploadingModal();
            }
        });
        progress_all_div.appendChild(file_name_span_node_close);
        single_progress.appendChild(progress_all_div);
        upload_status_parent.appendChild(single_progress);
        axios({
            method: 'post',
            crossdomain: true,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*'
            },
            cancelToken: ajaxRequest.token,
            data: formData,
            url: upload_url,
            onUploadProgress: (ev) => {
                let progress = ev.loaded / ev.total * 100;
                progress_bar_div.innerHTML = Math.round(progress) + "%";
                progress_bar_div.setAttribute("aria-valuenow", Math.round(progress));
                progress_bar_div.style.width = Math.round(progress) + "%";
            },
        }).then((resp) => {
            //console.log(resp.data);
            fileInput.value = "";
            if (resp.data.status == -1) {
                clearSession();
            } else if (resp.data.status === 0) {
                progress_bar_div.classList.remove("bg-success");
                progress_bar_div.classList.add("bg-danger");
                progress_bar_div.setAttribute("aria-valuenow", 100);
                progress_bar_div.style.width = "100%";
                progress_bar_div.innerHTML = "upload error, please try again";
                file_name_span_node_close.setAttribute("status", 1);
                //file_name_span_node_close.style.display = "block";
                Swal.fire('Error', resp.data.info, 'error');

            } else {
                file_name_span_node_close.setAttribute("status", 1);
                callback(resp.data.data);
            }
        }).catch((err) => {
                console.error(err);
                //upload_status_parent.style.display = "none";
            });
    }
    else if (action_name === "create_new_folder") {
        let pid = v1;
        let new_name = v2;
        
        // let valid_name = /^[a-zA-Z0-9_\u3000\u3400-\u4DBF\u4E00-\u9FFF]{2,20}$/;
        // if (!valid_name.test(new_name)) {
        //     Swal.fire(
        //         'Invalid Name!',
        //         'Please ensure the name is combined with aphlbets and numbers or undersccore and length should be [2,20]!',
        //         'error');
        //     return;
        // }

        if (new_name==="") {
            Swal.fire(
                'Invalid Name!',
                'Please ensure the name is not empty',
                'error');
            return;
        }

        let session = window.localStorage;
        axios.post(session.ch_action_url + "/action/add_new_project_folder", Qs.stringify({
            token: session.ch_token,
            parentid: pid,
            name: new_name
        })).then(res => {
            if (res.data.status === -1) {
                clearSession();
            }
            else if (res.data.status === 0) {
                console.log(res.data.info);
                Swal.fire(
                    'Operation Failed!',
                    res.data.info,
                    'error');
            }
            else {
                toast.success('The new folder has been created!', { position: toast.POSITION.TOP_CENTER, containerId: 'B' })
                callback(res.data.data);
            }
        });
    }
    else if (action_name === "move") {
        let session = window.localStorage;
        axios.post(session.uos_action_url + "/action/move_folder_file_instance", Qs.stringify({
            token: session.uos_token,
            id: v1,
            name: v2,
            type: v3,
            tid: v4
        })).then(res => {
            if (res.data == "-1") {
                clearSession();
            } else if (res.data.status === 0) {
                Swal.fire(
                    'Operation Failed!',
                    res.data.info,
                    'error');
            }
            else {
                callback(res.data.data);
            }
        });
    }
    else if (action_name === "delete") {
        Swal.fire({
            title: "Deletion",
            text: "Are you sure to delete this?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.value) {
                let session = window.localStorage;
                axios.post(session.ch_action_url + "/action/delete_single_project", Qs.stringify({
                    token: session.ch_token,
                    id: v1
                })).then(res => {
                    if (res.data.status === -1) {
                        clearSession();
                    }
                    else if (res.data.status === 0) {
                        Swal.fire(
                            'Operation Failed!',
                            res.data.info,
                            'error');
                    }
                    else {
                        callback();
                    }
                });
            }
        });
    }
    else if (action_name === "open_link") {
        let id=v1;
        let session = window.localStorage;
            axios.post(session.uos_action_url + "/action/get_single_file_url", Qs.stringify({
              token: session.uos_token,
              id: id
            })).then(res => {
              if (res.data == "-1") {
                clearSession();
              } else if (res.data.status === 0) {
                Swal.fire(
                  'Operation Failed!',
                  res.data.info,
                  'error');
              }
              else {
                let url = window.location.origin + "/" + res.data.data;
                window.open(url, "_blank");
                return;
              }
            });
    }
    else if (action_name === "download") {
        let session = window.localStorage;
        if (v3 === 4) {
            axios.post(session.ch_action_url + "/action/get_single_file_url", Qs.stringify({
                token: session.ch_token,
                id: v1
            })).then(res => {
                if (res.data == "-1") {
                    clearSession();
                } else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {
                    let url = `${window.location.origin.toString()}` + "/" + res.data.data;
                    let link = document.createElement("a");
                    link.download = v2;
                    link.href = url;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    link.remove();
                    return;
                }
            });
        }
        else {
            let session = window.localStorage;
            var link = document.createElement("a");
            link.download = v2;
            link.href = session.ch_action_url + "/action/download_project_zip?id=" + v1 + "&token=" + session.ch_token;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            link.remove();
        }
    }
    else if(action_name==="rename")
    {
        let pid = v1;
        let old_name=v2;
        let new_name = v3;

        if (new_name==="") {
            Swal.fire(
                'Invalid Name!',
                'Please ensure the name is not empty',
                'error');
            return;
        }
        if (new_name===old_name) {
            Swal.fire(
                'Invalid Name!',
                'Please ensure the name are not same!',
                'error');
            return;
        }

        let session = window.localStorage;
        axios.post(session.ch_action_url + "/action/update_project_file_name", Qs.stringify({
            token: session.ch_token,
            id: pid,
            name: new_name
        })).then(res => {
            if (res.data.status === -1) {
                clearSession();
            }
            else if (res.data.status === 0) {
                console.log(res.data.info);
                Swal.fire(
                    'Operation Failed!',
                    res.data.info,
                    'error');
            }
            else {
                toast.success('The new folder has been created!', { position: toast.POSITION.TOP_CENTER, containerId: 'B' })
                callback(res.data.data);
            }
        });
    }

}